import { useRef, useState, useEffect } from "react";
import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Flip, ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { styled } from '@mui/material/styles';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { IoArrowBackSharp } from "react-icons/io5";
import video1 from './Backgroundvideo.mp4';
import { CiMail } from "react-icons/ci";
import { GoPasskeyFill } from "react-icons/go";

/**
 * @fileoverview LoginForm component for user authentication.
 * @module LoginForm
 * @description Handles user login, error handling, password visibility toggle, and role-based redirection.
 */

const LoginForm = () => {

  const [loading, setLoading] = useState(false);  // State to manage loading indicator
  const history = useHistory();// React Router history for navigation
  const subBtn = useRef(null); // Reference to the submit button for keyboard event handling
  const [attemptCount, setAttemptCount] = useState(0);// State to track failed login attempts
  const [showError, setShowError] = useState(false);  // State to control error message display
  const [showPassword, setShowPassword] = useState(false);// State to toggle password visibility
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  }); // State to manage user login data

  /**
  * Handles input field changes and updates the state.
  * @param {Event} event - Input change event
  */
  const handleChange = (event) => {
    setLoginData({
      ...loginData,
      [event.target.name]: event.target.value
    });
  };

  /**
   * Handles login error responses and displays appropriate messages.
   * @param {Object} error - Axios error response
   */
  const handleLoginError = (error) => {
    if (error.response) {
      if (error.response.status === 400 && error.response.data.error.msg === "[ErrorDetail(string='You are not verified', code='invalid')]") {
        history.push("/Otpverify");
        return;
      }

      if (error.response.status === 404) {
        toast.error('Oops! Incorrect Credentials.', {
          position: "top-right",
          transition: Zoom,
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        return;
      }
    }
    // Display a generic error message for other errors
    toast.error('Error during login. Please try again.', {
      position: "top-right",
      transition: Zoom,
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    // Increment failed attempt count and show lockout message if threshold is reached
    setAttemptCount((prevCount) => prevCount + 1);
    if (attemptCount + 1 >= 3) {
      setShowError(true);
    }
  };

  /**
  * Handles login button click, performs validation, and sends API request.
  */
  const handleClick = async () => {
    if (loginData.email === '' || loginData.password === '') {
      toast.warn("Fields can't be empty!", { position: "top-right", transition: Flip, autoClose: 1500 });
      return;
    }

    try {
      const response = await toast.promise(
        axios.post(`${process.env.REACT_APP_BE_MAIN_URL}/user/login/`, loginData, {
          headers: { Accept: 'application/json' }
        }),
        {
          pending: 'Getting you in..!',
          success: 'Login successful! Redirecting...'
        }
      );

      if (response.status === 200) {
        const { access } = response.data.token;
        const role = response.data.token.role;
        sessionStorage.setItem("userToken", access);
        sessionStorage.setItem("userRole", role);

        setAttemptCount(0);
        setShowError(false);
        setTimeout(() => pushToDashboard(role), 1500);
      }
    } catch (error) {
      handleLoginError(error);
    }
  };

  /**
  * Redirects user to the appropriate dashboard based on role.
  * @param {string} role - User role retrieved from API response
  */
  const pushToDashboard = (role) => {
    if (role === "Admin") {
      history.push('/dashboard');
    } else if (role === "Customer") {
      history.push('/dashboard');
    } else if (role === "Annoter") {
      history.push('/task');
    } else {
      history.push('/task');
    }
  };

  /**
    * Adds an event listener to handle form submission on 'Enter' key press.
    */
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.keyCode === 13) {
        console.log("Enter");
        event.preventDefault();
        subBtn.current.click();
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  // Clears session storage on component mount
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  //  const handleTaskClick = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     history.push('/task');
  //   }, 1000); 
  // };

  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    fontFamily: 'Montserrat'
  }));

  /**
   * Toggles password visibility state.
   */
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex flex-col justify-center  items-center flex-1 h-screen px-6 py-12 lg:px-8  relative ">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
      >
        <source src={video1} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute top-6 left-6 text-white text-3xl cursor-pointer hover:text-orange-300 transition duration-300">
        <Link to="/"><IoArrowBackSharp size={40} /></Link>
      </div>

      <div className="  w-[520px]   transition-all duration-300 ease-in-out  ">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm ">
          <h2 className="mt-10 text-3xl font-bold leading-9 tracking-tight text-center text-white">Login your account!</h2>
        </div>
        <hr className="mt-4 mx-9 border-gray-400 bg-gray-400" />
        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-2" style={{ zIndex: "10", }}>
          {/* Email Input */}
          <div>
            <label htmlFor="email" className=" flex gap-2 text-[20px] font-medium leading-6 text-white" >
              <CiMail fontSize={24} />  Email
            </label>
            <div className=" relative mt-2">
              <input
                id="email"
                name="email"
                type="email"
                required
                className="block w-full h-[44px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>
          <div>
            {/* Password Input */}
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="flex gap-2 text-[20px] font-medium leading-6 text-white">
                <GoPasskeyFill fontSize={24} /> Password
              </label>
            </div>
            <div className="relative mt-2">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                required
                className="block w-full h-[40px] bg-gray-700/20 rounded-md border border-gray-400 p-2 text-white shadow-sm  ring-gray-500/50 placeholder:text-gray-300 sm:text-xl sm:leading-6 outline-none focus:border-gray-300 focus:ring-gray-300"
                onChange={(event) => handleChange(event)}
              />
              <div
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <FaEye color="white" size={20} /> : <FaEyeSlash color="white" size={20} />}
              </div>
            </div>
            <Link className="text-xl text-white hover:text-orange-300 float-right mt-1 transition duration-300">Forgot Password?</Link>
          </div>
          <div>

            < Link to="/task" className="font-medium text-xl text-white hover:text-orange-300 transition duration-300"></Link>
            {/* Submit Button */}
            <button
              type="submit"
              className="mt-2 h-[40px] w-full rounded-md text-xl  transition delay-150 duration-300   bg-orange-400 text-white font-bold shadow-md hover:bg-white hover:text-orange-400 hover:border border-orange-400"
              onClick={() => handleClick()}
              ref={subBtn}
            >
              Submit
            </button>
            {/* Lockout Error Message */}
            {showError && (
              <div className="mt-4 text-white text-center text-lg font-semibold ">
                Your account is locked due to multiple failed login attempts. Please reset your password!
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default LoginForm;
